export const SUCCESS_UPDATE_SCHEDULES = "SUCCESS_UPDATE_SCHEDULES";
export const SUCCESS_SCHEDULES = "SUCCESS_SCHEDULES";
export const SUCCESS_LIMITS = "SUCCESS_LIMITS";

export const UPDATE_SPENDING_LIMIT = "UPDATE_SPENDING_LIMIT";
export const RESET_SCHEDULE = "RESET_SCHEDULE";
export const UPDATE_DAY = "UPDATE_DAY";